import { commonjsGlobal as _ } from "./index.es13.js";
import { __exports as n } from "./index.es95.js";
import I from "./index.es93.js";
import R from "./index.es91.js";
var m;
function O() {
  if (m) return n;
  m = 1;
  var p = _ && _.__importDefault || function(e) {
    return e && e.__esModule ? e : { default: e };
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), n.escapeUTF8 = n.escape = n.encodeNonAsciiHTML = n.encodeHTML = n.encodeXML = void 0;
  var x = p(I), f = F(x.default), s = v(f);
  n.encodeXML = h(f);
  var A = p(R), a = F(A.default), M = v(a);
  n.encodeHTML = L(a, M), n.encodeNonAsciiHTML = h(a);
  function F(e) {
    return Object.keys(e).sort().reduce(function(r, t) {
      return r[e[t]] = "&" + t + ";", r;
    }, {});
  }
  function v(e) {
    for (var r = [], t = [], c = 0, D = Object.keys(e); c < D.length; c++) {
      var l = D[c];
      l.length === 1 ? r.push("\\" + l) : t.push(l);
    }
    r.sort();
    for (var u = 0; u < r.length - 1; u++) {
      for (var o = u; o < r.length - 1 && r[o].charCodeAt(1) + 1 === r[o + 1].charCodeAt(1); )
        o += 1;
      var C = 1 + o - u;
      C < 3 || r.splice(u, C, r[u] + "-" + r[o]);
    }
    return t.unshift("[" + r.join("") + "]"), new RegExp(t.join("|"), "g");
  }
  var d = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, j = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      function(e) {
        return e.codePointAt(0);
      }
    ) : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(e) {
        return (e.charCodeAt(0) - 55296) * 1024 + e.charCodeAt(1) - 56320 + 65536;
      }
    )
  );
  function i(e) {
    return "&#x" + (e.length > 1 ? j(e) : e.charCodeAt(0)).toString(16).toUpperCase() + ";";
  }
  function L(e, r) {
    return function(t) {
      return t.replace(r, function(c) {
        return e[c];
      }).replace(d, i);
    };
  }
  var g = new RegExp(s.source + "|" + d.source, "g");
  function T(e) {
    return e.replace(g, i);
  }
  n.escape = T;
  function E(e) {
    return e.replace(s, i);
  }
  n.escapeUTF8 = E;
  function h(e) {
    return function(r) {
      return r.replace(g, function(t) {
        return e[t] || i(t);
      });
    };
  }
  return n;
}
export {
  O as __require
};
//# sourceMappingURL=index.es89.js.map
